import {Component, Input, OnInit} from '@angular/core';
import {WelfareResultService} from '../../../../core/service/welfare-result.service';
import {Desktop} from '../../../../core/class/desktop';
import {Person} from '../../../../core/class/person';
import {PersonKind} from '../../../../core/class/person-kind.enum';
import {NbWindowService} from '@nebular/theme';
import {PdfViewerComponentComponent} from '../../../../core/components/pdf-viewer-component/pdf-viewer-component.component';

interface CCNLRes {
  fileName: string,
  name: string;
}

@Component({
  selector: 'app-desktop',
  templateUrl: './desktop.component.html',
  styleUrls: ['./desktop.component.css']
})
export class DesktopComponent implements OnInit {

  @Input()
  desktop: Desktop;
  cnls: CCNLRes[];
  private readonly ccnlSummaryUrl = 'https://prospettivawefare-public.s3.eu-west-1.amazonaws.com/resources/cnl/summ.pdf';
  private static readonly CNL_BASE_URL = 'https://prospettivawefare-public.s3.eu-west-1.amazonaws.com/resources/cnl/';

  constructor(public welfareService: WelfareResultService,
              private windowService: NbWindowService) {
  }

  ngOnInit() {
    this.intCNL();
  }

  private intCNL() {
    this.cnls = [
      {
        name: 'Fasa',
        fileName: 'fasa.pdf'
      },
      {
        name: 'Fasdac',
        fileName: 'fasdac.pdf'
      },
      {
        name: 'Fisi Open',
        fileName: 'fisi+open.pdf'
      },
      {
        name: 'Fasi',
        fileName: 'fasi.pdf'
      },
      {
        name: 'Fond Est',
        fileName: 'fond+est.pdf'
      },
      {
        name: 'Fond sanitari',
        fileName: 'fondi+sanitari.pdf'
      },
      {
        name: 'Meta salute',
        fileName: 'metasalute.pdf'
      },
      {
        name: "Quas",
        fileName: 'quas.pdf'
      },
      {
        name: 'Sanarti',
        fileName: 'sanarti.pdf'
      },
      {
        name: 'Sanilog',
        fileName: 'sanilog.pdf'
      }
    ];
  }

  public isMonoIncome() {
    let husband: Person;
    let wife: Person;
    let ret = false;

    this.welfareService.persons.forEach(value => {
      if (value.kind === PersonKind.HUSBAND) {
        husband = value;
      } else if (value.kind === PersonKind.WIFE) {
        wife = value;
      }
    });

    if (this.desktop.theoryIncomeOption && husband && wife) {
      ret = husband.incomeWeight <= 0 || wife.incomeWeight <= 0;
    } else if (husband && wife) {
      const hIncome = husband.income + husband.secondIncome;
      const wIncome = wife.income + wife.secondIncome;
      ret = hIncome <= 0 || wIncome <= 0;
    }
    return ret;
  }

  public containsChild(): boolean {
    let ret = false;
    if (this.welfareService.persons) {
      this.welfareService.persons.forEach(value => {
        if (value.kind === PersonKind.CHILD) {
          ret = true;
        }
      });
    }
    return ret;
  }

  getFamilyHead(): Person[] {
    const ret = [];

    this.welfareService.persons.forEach(person => {
      if (person.kind === PersonKind.HUSBAND || person.kind === PersonKind.WIFE || person.kind === PersonKind.SINGLE) {
        ret.push(person);
      }
    });

    return ret;
  }


  showCCNLPdf(cnlName: string) {
    //search cnl using given name
    const cnl = this.cnls.find(value => value.name == cnlName);

    //build url
    const url = DesktopComponent.CNL_BASE_URL + cnl.fileName;

    //open pdf
    this.windowService.open(PdfViewerComponentComponent, {title: 'CNL', context: {pdfSrc: url}});
  }

  showSummary() {
    this.windowService.open(PdfViewerComponentComponent, {title: 'Info', context: {pdfSrc: this.ccnlSummaryUrl}});
  }
}
